<template>
  <div>
    <div style="display: flex">
      <div
        class="tabs"
        @click="handleClick(item, index)"
        v-for="(item, index) in tabList"
        :key="index"
        :style="{
          borderColor: index === cIndex ? '#c6e3eb' : '#3e4860',
          color: '#fff',
          background:
            index === cIndex
              ? 'linear-gradient(to bottom, #1a3a5c, #295d8c)'
              : 'transparent',
          fontSize: index === cIndex ? '17px' : '14px',
          cursor: 'pointer',
          padding: '10px 10px',
          marginRight: '10px',
          border: '1px solid'
        }"
      >
        {{ item.label }}
      </div>
    </div>

    <el-carousel
      v-if="currentType === 'weekly' && show_big_img"
      style="width: 1060px; height: 545px; text-align: center; padding: 10px 0"
      class="right-ul"
      indicator-position="none"
      :arrow="contorl"
      :interval="5000"
    >
      <el-carousel-item v-for="(item, index) in caipuList" :key="index">
        <div class="right-li">
          <el-image
            style="width: 95%; height: 525px; border-radius: 15px; opacity: 0.95;"
            :src="item.big_img"
            :preview-src-list="[item.big_img]"
          ></el-image>
        </div>
      </el-carousel-item>
    </el-carousel>

    <gongyingshang
      v-if="currentType === 'supplier_gs'"
      style="width: 1060px; height: 545px; text-align: center"
      :suppliers="suppliers"
      :tabs="tabs"
    ></gongyingshang>

    <el-carousel
      v-if="currentType === 'supplier_zz'"
      style="width: 1060px; height: 545px; text-align: center; padding: 10px 0"
      class="right-ul gongyingshang"
      indicator-position="none"
      :arrow="contorl"
      :interval="5000"
    >
      <el-carousel-item v-for="(group, index) in groupedSuppList" :key="index" style="display: flex; justify-content: space-evenly">
        <div v-for="(item, subIndex) in group" :key="subIndex" class="right-li" style="width: 33%; position: relative; top: -20px">
          <el-image
            style="transform: scale(0.7); object-fit: contain; padding: 4px; border: 1px solid #f6f6f6;"
            :src="item.business_images"
            :preview-src-list="businessImage"
          ></el-image>
          <div style="padding: 10px 30px; position: absolute; bottom: 30px; left: 50%; transform: translateX(-50%); width: 100%;">
            {{ item.name }}
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <el-carousel
      v-if="currentType === 'analysis'"
      style="width: 1060px; height: 545px; text-align: center; padding: 10px 0"
      class="right-ul"
      :arrow="contorl"
      :interval="5000"
      indicator-position="none"
    >
      <el-carousel-item v-for="(item, index) in analysisList" :key="index">
        <div class="right-li" style="background-color: white; padding: 10px 0; width: 95%; margin: 0 auto;">
          <el-image style="width: 95%; height: 505px; opacity: 0.95" :src="item" :preview-src-list="analysisList"></el-image>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div v-if="currentType === 'health'">
      <el-carousel
        style="width: 1060px; height: 450px !important; text-align: center; padding: 10px 0"
        class="right-ul health-cert-carousel"
        indicator-position="none"
        :arrow="contorl"
        :interval="5000"
      >
        <el-carousel-item v-for="(group, index) in groupedHealthList" :key="index" style="display: flex; justify-content: flex-start; flex-wrap: wrap">
          <div v-for="(item, subIndex) in group" :key="subIndex" class="right-li" style="width: 33%; position: relative; height: 230px">
            <el-image
              style="transform: scale(0.9); object-fit: contain; height: 170px; width: 300px; border: 1px solid #f6f6f6;"
              :src="item.pic_image"
              :preview-src-list="healthImage"
            ></el-image>
            <div style="padding: 10px; position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); width: 100%;">
              <span style="margin-right: 10px"> 姓名： {{ item.name }}</span>
              <span style="margin-left: 20px">到期日期：{{ item.end_date }}</span>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div style="width: 1060px; margin-top: 5px; background: rgba(86, 181, 249, 0.1); border: 1px solid rgba(86, 181, 249, 0.3); border-radius: 4px; display: flex; justify-content: space-around; align-items: center; height: 40px;">
        <div class="stat-item">30天内到期：<b style="color:#ff4d4d">{{month_count}}</b>个</div>
        <div class="stat-item">提前办理中：<b style="color:#ffa500">{{week_count}}</b>个</div>
      </div>
    </div>

    <el-carousel
      v-if="['custom1', 'custom2', 'custom3'].includes(currentType)"
      style="width: 1060px; height: 545px; text-align: center; padding: 10px 0"
      class="right-ul"
      :arrow="contorl"
      :interval="5000"
      indicator-position="none"
    >
      <el-carousel-item v-for="(item, index) in activeImgs" :key="index">
        <div class="right-li">
          <el-image
            style=" height: 525px; border-radius: 15px; opacity: 0.95;object-fit: contain;"
            :src="item"
            :preview-src-list="activeImgs"
          ></el-image>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="carousel-tables" v-if="isTableMode">
      <div class="carousel-slider" :style="{ transform: `translateX(-${currentPage * 100}%)` }">
        <div v-for="(chunk, index) in chunkedData" :key="index" class="carousel-item">
          <el-table stripe :data="chunk" :height="510" class="tableWrap" ref="rolltable">
            <el-table-column v-if="shelf" type="selection" width="55"></el-table-column>
            
            <template v-for="(item, colIndex) in tableTitle">
              <el-table-column
                v-if="!item.childrens"
                :key="colIndex"
                :prop="item.value"
                :label="item.name"
                :width="item.width"
                align="center"
              >
                <template #default="scope">
                  <template v-if="item.value === 'supplier'">
                    <span @click="toggleSupplierDisplay(scope.row)" style="cursor: pointer">
                      {{ showSupplier[scope.row.id] ? scope.row[item.value] : "******" }}
                    </span>
                  </template>

                  <template v-else-if="['check_images', 'business_images', 'pic_image', 'company_image', 'waste_image', 'arr_food_images', 'business_license_images_arr', 'purchase_voucher_images_arr', 'scene_img', 'picture_img', 'product_report_images_arr', 'imgs', 'other_report_images_arr', 'license_images_arr', 'images_arr'].includes(item.value)">
                    <div class="image-container">
                      <template v-if="typeof scope.row[item.value] === 'string' && scope.row[item.value]">
                        <el-image :src="scope.row[item.value]" :preview-src-list="[scope.row[item.value]]" style="width: 60px; height: 40px; object-fit: contain;"></el-image>
                      </template>
                      <template v-else-if="Array.isArray(scope.row[item.value])">
                        <el-image v-for="(img, i) in scope.row[item.value]" :key="i" :src="img" :preview-src-list="scope.row[item.value]" style="width: 40px; height: 40px; margin-right: 5px"></el-image>
                      </template>
                      <template v-else><span style="color: #999">无图片</span></template>
                    </div>
                  </template>

                  <template v-else-if="item.value === 'status' || item.value === 'health'">
                    <span :style="scope.row[item.value] && (scope.row[item.value].includes('不合格') || scope.row[item.value].includes('开')) ? 'color: red;' : ''"
                          v-html="formatHealthContent(scope.row, item.value)"></span>
                  </template>

                  <template v-else>
                    <slot :name="item.value" :scope="scope" v-if="$scopedSlots[item.value]"></slot>
                    <template v-else>
                       <img v-if="item.value == 'due_days' && scope.row[item.value] < 30" src="../assets/image/isdue.png" style="width: 40px; vertical-align: bottom; margin-right: 8px;" />
                       <span v-html="formatCellContent(scope.row, item.value)"></span>
                    </template>
                  </template>
                </template>
              </el-table-column>

              <el-table-column v-else :key="'nested-'+colIndex" :label="item.label">
                <el-table-column v-for="(child, childIndex) in item.childrens" :key="childIndex" :prop="child.value" :label="child.name" :width="child.width" align="center">
                  <template slot-scope="scope">
                    <slot :name="child.value" :scope="scope" v-if="$scopedSlots[child.value]"></slot>
                    <span v-else>{{ scope.row[child.value] }}</span>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>
          </el-table>
          <div class="next" @click="nextPage"><img src="../assets/image/next2.png" /></div>
          <div class="prev" @click="prevPage"><img src="../assets/image/prev.png" /></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gongyingshang from "./gongyingshang.vue";
import {
  getTastingTable, getMenuTable, getRetentionTable, getWasteTable, getCzjxdTable,
  getHealthcheckTable, getCjxdTable, getArea8cleanTable, getPsgcleanTable,
  getCzjselfcheckTable, getColdstorecheckTable, getPestcontrolTable, getCloseshopTable,
  getSupplierTable, getPriceView, getDDUserTemp, getPesticideheck, getERPTruckTzList,
  getXdjl, getProblemList, getPesticideBymachine, getFoodTjj, getFogetFoodbzqodTjj,
  getCustomImgs, getCustomImgs2, getCustomImgs3, getTruckTzList, getBlocks,
  getFoodAnalysis, getMorningCheck, getMorningCheckByMachine, getHealthTable,
  getSupplier2, getHealthcertCount
} from "../api/api";
import { baseImgUrl } from "../utils/request";

export default {
  props: ["shelf", "tabList2"],
  components: { gongyingshang },
  data() {
    return {
      cIndex: 0,
      currentIndex: 0,
      currentTable: "", // 当前标题
      currentType: "",  // 当前类型识别码
      tabList: [],
      tableTitle: [],
      tableSource: [],
      allTabsDate: {}, // 统一命名
      customTitle: "", customTitle2: "", customTitle3: "",
      customImgs: [], customImgs2: [], customImgs3: [],
      caipuList: [], analysisList: [], healthList: [],
      healthImage: [], businessImage: [],
      suppliers: {}, tabs: [],
      month_count: 0, week_count: 0, all_count: 0,
      currentPage: 0, lastCurrentPage: 0,
      contorl: "hover",
      showSupplier: {},
      show_big_img: false,
      show_price: false,
      showScore: 0,
      showFoodimages: 0,
      timer: null,
      intervalId2: null,
      cleanUpMemory: null,
      requestData: { start_date: "", end_date: "", page: 1, search_key: "", cat_name: "", from: "inner" }
    };
  },
  computed: {
    isTableMode() {
      const specialTypes = ['weekly', 'supplier_gs', 'supplier_zz', 'analysis', 'health', 'custom1', 'custom2', 'custom3'];
      return !specialTypes.includes(this.currentType);
    },
    activeImgs() {
      if (this.currentType === 'custom1') return this.customImgs;
      if (this.currentType === 'custom2') return this.customImgs2;
      if (this.currentType === 'custom3') return this.customImgs3;
      return [];
    },
    chunkedData() {
      if (!this.tableSource) return [];
      const size = (this.currentTable === "产品入库溯源记录") ? 6 : (this.currentTable === "智能晨检仪" ? 5 : 11);
      const chunks = [];
      for (let i = 0; i < this.tableSource.length; i += size) chunks.push(this.tableSource.slice(i, i + size));
      return chunks;
    },
    groupedSuppList() {
      const list = this.allTabsDate["供应商资质管理"] || [];
      const chunks = [];
      for (let i = 0; i < list.length; i += 3) chunks.push(list.slice(i, i + 3));
      return chunks;
    },
    groupedHealthList() {
      const chunks = [];
      for (let i = 0; i < this.healthList.length; i += 6) chunks.push(this.healthList.slice(i, i + 6));
      return chunks;
    }
  },
  methods: {
    async handleClick(tab, i) {
      if (!tab) return;
      this.cIndex = i;
      this.currentIndex = i;
      this.currentTable = tab.label;
      this.currentType = tab.type;
      this.currentPage = 0;

      // 特殊UI轮播控制
      const alwaysArrows = ['weekly', 'health', 'analysis', 'custom1', 'custom2', 'custom3', 'supplier_zz'];
      this.contorl = alwaysArrows.includes(tab.type) ? "always" : "hover";

      // 处理表格配置 (保留你原来的所有 else if 逻辑)
      if (this.isTableMode || tab.type === 'supplier_zz') {
        this.loadTableConfigs(tab);
      }
    },

    loadTableConfigs(tab) {
      const label = tab.rawLabel || tab.label;
      // 这里的逻辑对应你代码中 handleClick 里的那些 else if
      if (label === "品尝记录") {
        this.getTastingTable();
        this.tableTitle = [
          { name: "日期", value: "date" }, { name: "餐次", value: "meal_name" },
          { name: "档口", value: "room_name" }, { name: "菜品名称", value: "food_name" },
          { name: "中心温度", value: "temp" }, { name: "数量", value: "taste_number" },
          { name: "结果", value: "taste_result" }, { name: "品尝人", value: "taste_user" }
        ];
      } else if (label === "每日留样") {
        this.tableSource = this.allTabsDate["每日留样"] || [];
        this.tableTitle = [
          { name: "留样时间", value: "action_date" }, { name: "餐次", value: "meal_name" },
          { name: "菜品名称", value: "food_name" }, { name: "保存条件", value: "temp" },
          { name: "重量", value: "weight" }, { name: "留样人", value: "retention_user" }
        ];
      } else if (label === "废弃物处理") {
        this.getWasteTable();
        this.tableTitle = [
          { name: "日期", value: "action_date" }, { name: "种类", value: "class" },
          { name: "数量", value: "number" }, { name: "联系方式", value: "phone" },
          { name: "经手人", value: "handler_user_name" }, { name: "图片", value: "waste_image" }
        ];
      } else if (label === "供应商资质管理") {
        this.tableSource = this.allTabsDate["供应商资质管理"] || [];
        // 根据 showScore 等动态配置表头
        if (this.showScore) {
          this.tableTitle = [{ name: "供应商名称", value: "name", width: "380" }, { name: "营业执照", value: "business_images" }, { name: "评分", value: "score" }];
        } else {
          this.tableTitle = [{ name: "供应商名称", value: "name", width: "380" }, { name: "营业执照", value: "business_images" }];
        }
      } else if (label === "价格公示") {
        this.tableSource = this.allTabsDate["价格公式"] || [];
        this.tableTitle = [{ name: "档口", value: "gearOpening" }, { name: "产品名", value: "name" }, { name: "价格", value: "price" }];
      } else if (label === "农残检测") {
        this.tableSource = this.allTabsDate["农残检测"] || [];
        this.tableTitle = [
          { name: "检测日期", value: "date" }, { name: "菜品", value: "food_name" },
          { name: "供应商", value: "supplier", width: "250" }, { name: "图片", value: "check_images" },
          { name: "结果", value: "status_name" }
        ];
      } else if (label === "消毒记录") {
        this.tableSource = this.allTabsDate["消毒记录"] || [];
        this.tableTitle = [
          { name: "消毒日期", value: "date" }, { name: "部门", value: "room_name" },
          { name: "名称", value: "name" }, { name: "方式", value: "method" },
          { name: "操作人", value: "operator_user" }
        ];
      } else if (label === "智能晨检仪") {
        this.tableSource = this.allTabsDate["智能晨检仪"] || [];
        this.tableTitle = [
          { name: "晨检日期", value: "date" }, { name: "员工姓名", value: "personName" },
          { name: "人脸照片", value: "scene_img" }, { name: "手部照片", value: "picture_img" },
          { name: "体温", value: "temperature" }, { name: "结果", value: "health" }
        ];
      } else {
        // 其他通用表格处理...
        this.tableSource = this.allTabsDate[label] || [];
      }
    },

    // 数据初始化逻辑
    async getBlocksTable() {
      try {
        const res = await getBlocks({ from: "home" });
        const raw = res.data.data;
        this.tabList = raw.map(str => {
          let type = "table";
          let label = str;
          if (str === "自定义图片模块") { label = this.customTitle || str; type = "custom1"; }
          else if (str === "自定义图片模块2") { label = this.customTitle2 || str; type = "custom2"; }
          else if (str === "自定义图片模块3") { label = this.customTitle3 || str; type = "custom3"; }
          else if (str === "每周菜谱") type = "weekly";
          else if (str === "供应商公示") type = "supplier_gs";
          else if (str === "供应商资质管理") type = "supplier_zz";
          else if (str === "菜品营养分析") type = "analysis";
          else if (str === "健康证展示") type = "health";
          return { label, type, rawLabel: str };
        });

        // 异步加载所有数据
        const methodMap = {
          "每日留样": () => this.getRetentionTables(),
          "价格公示": () => this.getPriceAndInitializeTable(),
          "每周菜谱": () => this.getMenuTables(),
          "供应商资质管理": () => this.getSupplierTables(),
          "农残检测": () => this.getPesticideheckTable(),
          "消毒记录": () => this.getXdjlTable(),
          "智能晨检仪": () => this.getMorningCheckByMachine(),
          "健康证展示": () => this.getHealthTable(),
          "供应商公示": () => this.getSupplier2(),
          "菜品营养分析": () => this.getgetFoodAnalysisData()
        };

        const promises = this.tabList
          .filter(item => methodMap[item.rawLabel])
          .map(item => methodMap[item.rawLabel]());
        
        await Promise.all(promises);
        if (this.tabList.length > 0) this.handleClick(this.tabList[0], 0);
      } catch (e) { console.error(e); }
    },

    // --- API 具体实现 (完整保留并修正) ---
    async getHealthTable() {
      const res = await getHealthTable({ order: "desc", orderby: "end_date" });
      this.healthImage = [];
      this.healthList = res.data.data[0].data.map(item => {
        if (item.pic_image && !item.pic_image.includes("http")) item.pic_image = baseImgUrl + item.pic_image;
        this.healthImage.push(item.pic_image);
        return item;
      });
      const resCount = await getHealthcertCount();
      this.week_count = resCount.data.data.week_count;
      this.month_count = resCount.data.data.month_count;
      this.all_count = resCount.data.data.all_count;
    },
    async getCustomImgs() {
      const res = await getCustomImgs();
      if (res.data.code == 1) {
        this.customTitle = res.data.data.title;
        this.customImgs = res.data.data.imgs;
      }
    },
    async getCustomImgs2() {
      const res = await getCustomImgs2();
      if (res.data.code == 1) {
        this.customTitle2 = res.data.data.title;
        this.customImgs2 = res.data.data.imgs;
      }
    },
    async getCustomImgs3() {
      const res = await getCustomImgs3();
      if (res.data.code == 1) {
        this.customTitle3 = res.data.data.title;
        this.customImgs3 = res.data.data.imgs;
      }
    },
    async getMenuTables() {
      const res = await getMenuTable();
      this.show_big_img = res.data.data[0]?.show_big_img;
      if (this.show_big_img) this.caipuList = res.data.data[0].data;
      else this.allTabsDate["每周菜谱"] = res.data.data[0].data;
    },
    async getSupplierTables() {
      const res = await getSupplierTable();
      this.showScore = res.data?.data?.data[0]?.show_score;
      this.businessImage = [];
      this.suppList = res.data.data?.data.map(item => {
        if (item.business_images && !item.business_images.includes("http")) {
          item.business_images = baseImgUrl + item.business_images;
          this.businessImage.push(item.business_images);
        }
        return item;
      });
      this.allTabsDate["供应商资质管理"] = this.suppList;
    },
    async getPriceAndInitializeTable() {
      const res = await getPriceView();
      let all = [];
      Object.entries(res.data.data).forEach(([key, val]) => {
        if (val.list) all.push(...val.list.map(i => ({ ...i, gearOpening: key })));
      });
      this.$set(this.allTabsDate, "价格公式", all);
    },
    async getMorningCheckByMachine() {
      const res = await getMorningCheckByMachine();
      const data = res?.data?.data?.data || [];
      this.allTabsDate["智能晨检仪"] = data.map(i => ({
        ...i,
        health: i.picture_recognition_content ? `${i.health}（${i.picture_recognition_content}）` : i.health,
        picture_img: [i.picture_img, i.picture_back_img].filter(Boolean).map(img => img.includes('http') ? img : baseImgUrl + img),
        scene_img: i.scene_img?.includes('http') ? i.scene_img : baseImgUrl + i.scene_img
      }));
    },
    async getXdjlTable() {
      const res = await getXdjl();
      this.allTabsDate["消毒记录"] = res.data.data.data;
    },
    async getPesticideheckTable() {
      const res = await getPesticideheck();
      this.allTabsDate["农残检测"] = res.data.data.data.map(i => ({
        ...i, check_images: i.check_images.includes("http") ? i.check_images : baseImgUrl + i.check_images
      }));
    },
    async getgetFoodAnalysisData() {
      const res = await getFoodAnalysis();
      this.analysisList = res.data.data?.map(i => i.food_analysis_img) || [];
    },
    async getRetentionTables() {
      const res = await getRetentionTable();
      this.allTabsDate["每日留样"] = res.data.data[0].data.map(i => ({
        ...i, pic_image: i.pic_image?.includes("http") ? i.pic_image : baseImgUrl + i.pic_image
      }));
    },
    async getSupplier2() {
      const res = await getSupplier2();
      this.suppliers = res.data.data;
      this.tabs = res.data.data.sort;
    },
    async getTastingTable() {
      const res = await getTastingTable();
      this.tableSource = res.data.data[0].data;
    },
    async getWasteTable() {
      const res = await getWasteTable();
      this.tableSource = res.data.data[0].data.map(i => ({
        ...i, waste_image: i.waste_image.includes("http") ? i.waste_image : baseImgUrl + i.waste_image
      }));
    },
    // --- 辅助工具方法 ---
    toggleSupplierDisplay(row) {
      this.$set(this.showSupplier, row.id, !this.showSupplier[row.id]);
    },
    nextPage() {
      if (this.chunkedData.length > 0) this.currentPage = (this.currentPage + 1) % this.chunkedData.length;
    },
    prevPage() {
      if (this.currentPage > 0) this.currentPage--;
    },
    formatCellContent(row, field) {
      const v = row[field];
      if (v === null || v === undefined) return "";
      if (typeof v === "string") return v.replace(/\r\n/g, "<br>");
      if (field === "due_days" && v >= 0) return `${v}天`;
      return v;
    },
    formatHealthContent(row, field) {
      return row[field] || "";
    },
    startAutoPlay() {
      this.timer = setInterval(() => this.nextPage(), 8000);
    }
  },
  async mounted() {
    // 1. 先获取自定义模块标题（因为 getBlocksTable 依赖它）
    await Promise.all([this.getCustomImgs(), this.getCustomImgs2(), this.getCustomImgs3()]);
    // 2. 初始化 Tab 和其他数据
    await this.getBlocksTable();
    
    this.startAutoPlay();

    // 3. 页面轮播切换 (30秒换一个Tab)
    this.intervalId2 = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.tabList.length;
      this.handleClick(this.tabList[this.currentIndex], this.currentIndex);
    }, 30000);

    // 4. 内存清理/刷新定时器
    this.cleanUpMemory = setInterval(() => {
      this.getCustomImgs(); this.getCustomImgs2(); this.getCustomImgs3();
    }, 15 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.intervalId2);
    clearInterval(this.cleanUpMemory);
  }
};
</script>



<style lang="scss" scoped>
.right-ul::v-deep .el-table--scrollable-y .el-table__body-wrapper {
  overflow-y: hidden !important;
}
/* 覆盖轮播箭头样式 */
.right-ul::v-deep .el-carousel__arrow {
  width: 35px;
  height: 35px;
  margin-top: 100px;
  // background: rgba(24, 144, 255, 0.35) !important;
  backdrop-filter: blur(2px);
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  // transition: all 0.3s ease;
}

/* 悬停效果 */
.right-ul::v-deep .el-carousel__arrow:hover {
  background: rgba(24, 144, 255, 0.9) !important;
  // transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

/* 箭头图标颜色 */
.right-ul::v-deep .el-carousel__arrow i {
  color: white;
  font-size: 24px;
  font-weight: bold;
}

/* 左右按钮位置微调 */
.right-ul::v-deep .el-carousel__arrow--left {
  left: 20px;
}

.right-ul::v-deep .el-carousel__arrow--right {
  right: 20px;
}
.tabs {
  flex-grow: 1;
  background-color: transparent;
  border: 2px solid rgb(18, 139, 255);
  border-radius: 5px;
  margin: 5px;
  padding: 10px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-weight: bolder;
}
.tabs:active {
  border-color: #c6e3eb !important;
}
::v-deep .el-tabs__item.is-active {
  color: #409eff !important;
}
::v-deep .el-carousel__item {
  height: 545px;
}
/* 精确控制当前组件的轮播高度 */
::v-deep .health-cert-carousel .el-carousel__item {
  height: 450px !important;
}
::v-deep .gongyingshang .el-image__inner {
  height: 525px !important;
}
.left-three-item {
  transition: all 0.5s ease; /* 过渡动画效果 */
}
</style>
<style scoped>
.el-image-viewer__mask {
  opacity: 1 !important;
  background: linear-gradient(
    45deg,
    rgba(0, 0, 0, 0.8),
    rgba(20, 20, 20, 0.9)
  ) !important;
}

::v-deep .right-ul .right-li .el-image-viewer__img {
  border-radius: 15px !important;
}
/*  */
.carousel-tables {
  position: relative;
  overflow: hidden;
  width: 1060px;
  height: 520px;
  text-align: center;
  padding: 10px 0;
}

.carousel-slider {
  display: flex;
  transition: transform 0.1s ease-out 0.2s;
}

.carousel-item {
  min-width: 100%;
  box-sizing: border-box;
  height: 530px;
  position: relative;
  background-color: rgba(163, 160, 169, 0.4);
}
.next {
  position: absolute;
  top: 220px;
  right: 20px;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  -webkit-tap-highlight-color: transparent;
  /* background: rgba(24, 144, 255, 0.35) !important; */
  backdrop-filter: blur(2px);
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  img {
    width: 20px;
    height: 20px;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }
}
.next:hover,
.next:active {
  background: rgba(24, 144, 255, 0.9) !important;
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}
.prev {
  position: absolute;
  top: 220px;
  left: 20px;
  width: 35px;
  height: 35px;
  line-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 100;
  -webkit-tap-highlight-color: transparent;
  /* background: rgba(24, 144, 255, 0.35) !important; */
  backdrop-filter: blur(2px);
  border: 2px solid #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  img {
    width: 20px;
    height: 20px;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
  }
}
.prev:hover,
.prev:active {
  background: rgba(24, 144, 255, 0.9) !important;
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}
/* 全局加载层样式 */
.global-loading-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: rgb(64, 158, 255);
  z-index: 2000;
}

.el-icon-loading {
  font-size: 40px;
  margin-bottom: 16px;
  animation: rotating 2s linear infinite;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 统计项样式 */
.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 15px;
}

.stat-number {
  font-size: 22px;
  font-weight: bold;
  color: rgb(86, 181, 249);
  margin-bottom: 4px;
}

.stat-label {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
}
</style>
